import { autoinject } from "aurelia-dependency-injection";
import { BaseEnvironmentalVerificationTab } from "../base-environmental-verification-tab";
import { useView } from "aurelia-framework";

@autoinject
@useView('views/pages/modules/ghg/pages/request-an-environmental-verification/tabs/environmental-verification-additional-comments/environmental-verification-additional-comments.html')
export class EnvironmentalVerificationAdditionalComments extends BaseEnvironmentalVerificationTab {

}